import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { RegistryCredentialsPage } from '@/routes/registry-credentials/page'

export const RegistryCredentials = () => (
  <PageErrorBoundary>
    <RegistryCredentialsPage />
  </PageErrorBoundary>
)
